export const INJECTION_STATE_NOT_YET = 'NOT_YET';
export const INJECTION_STATE_IN_PROGRESS = 'IN_PROGRESS';
export const INJECTION_STATE_DONE = 'DONE';
